var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.length)?[_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.length))])]:[_vm._v(" "+_vm._s(_vm.emptyValuePlaceholder)+" ")],_c('custom-view',{ref:"view",attrs:{"images":_vm.images,"options":_vm.viewOption}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }